class InfinitePagination extends HTMLElement {
  constructor() {
    super();

    this.paginationEvent = this.dataset.paginationEvent;
    this.url = this.dataset.nextPage;
    this.previousUrl = this.dataset.previousPage || '';
    this.currentPage = parseInt(this.dataset.currentPage) || 1;
    this.button = document.getElementById('loadMore');
    this.previousButton = document.getElementById('loadPrevious');
    this.productLoaded = document.getElementById('LoadMoreCurrent');
    this.loader = document.querySelector('.pagination-loader');
    this.previousLoader = document.querySelector('.pagination-loader--previous');

    if (this.button) {
      if (this.paginationEvent === 'load_more') {
        this.button.addEventListener('click', () => {
          this.fetchProducts();
        });
      } else if (this.paginationEvent === 'infinite') {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          if (this.url === '') observer.unobserve(this.button);

          this.fetchProducts();
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this.button);
      }
    }

    // Handle Load Previous button
    if (this.previousButton) {
      this.previousButton.addEventListener('click', () => {
        this.fetchPreviousProducts();
      });
    }
  }

  updateLoadedProductNumber(isPrevious = false, productsCount = null) {
    if (!this.productLoaded) return;
    
    const paginationContainer = this.productLoaded.closest('.pagination');
    if (!paginationContainer) return;
    
    const productsLoaded = productsCount !== null 
        ? productsCount 
        : Number(this.productLoaded.dataset.loadMoreSize);
    
    if (isPrevious) {
      // When loading previous pages, decrease the starting number
      // Use provided count or calculate from data attribute
      const startingNumberElement = paginationContainer.querySelector('ul li:first-child');
      if (startingNumberElement) {
        const currentStart = parseInt(startingNumberElement.textContent.trim().replace(' -', '')) || 1;
        const newStart = Math.max(1, currentStart - productsLoaded);
        startingNumberElement.textContent = `${newStart} - `;
      }
    } else {
      // When loading next pages, increase the ending number
      // Use provided count or fall back to data attribute

      const currentEnd = Number(this.productLoaded.textContent);
      const newEnd = currentEnd + productsLoaded;
      const totalProducts = Number(this.productLoaded.dataset.loadMoreTotalSize);
      
      if (newEnd >= totalProducts) {
        this.productLoaded.textContent = totalProducts;
      } else {
        this.productLoaded.textContent = newEnd;
      }
    }
  }

  fetchProducts() {
    if (this.url != '') {
      this.loader.removeAttribute('hidden');
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const products = html.querySelector('#product-grid').innerHTML;
          
          // Count products loaded from the fetched page
          const fetchedProductGrid = html.querySelector('#product-grid');
          const productsLoaded = fetchedProductGrid 
            ? fetchedProductGrid.querySelectorAll('li.grid__item').length 
            : 0;

          if (products.length) {
            this.querySelector('#product-grid').insertAdjacentHTML('beforeend', products);
          }

          history.pushState({ scrollTop: document.body.scrollTop }, '', this.url);
          const paginationElement = html.querySelector('infinite-pagination');
          this.url = paginationElement ? paginationElement.dataset.nextPage : '';
          if (this.url === '' && this.button) {
            this.button.setAttribute('hidden', '');
          }
          this.loader.setAttribute('hidden', '');
          this.updateLoadedProductNumber(false, productsLoaded);
          swatches();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  fetchPreviousProducts() {
    if (this.previousUrl != '') {
      this.previousLoader.removeAttribute('hidden');
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      const productGrid = this.querySelector('#product-grid');
      const firstProductBefore = productGrid.querySelector('li.grid__item');

      fetch(this.previousUrl)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const products = html.querySelector('#product-grid').innerHTML;
          
          // Count products loaded from the fetched page
          const fetchedProductGrid = html.querySelector('#product-grid');
          const productsLoaded = fetchedProductGrid 
            ? fetchedProductGrid.querySelectorAll('li.grid__item').length 
            : 0;

          if (products.length) {
            productGrid.insertAdjacentHTML('afterbegin', products);
            
            // Maintain scroll position after prepending
            const firstProductAfter = productGrid.querySelector('li.grid__item');
            if (firstProductAfter && firstProductBefore) {
              const addedHeight = firstProductAfter.offsetTop - firstProductBefore.offsetTop;
              window.scrollTo(0, scrollPosition + addedHeight);
            }
          }

          history.pushState({ scrollTop: document.body.scrollTop }, '', this.previousUrl);
          const paginationElement = html.querySelector('infinite-pagination');
          if (paginationElement) {
            this.previousUrl = paginationElement.dataset.previousPage || '';
            this.currentPage = parseInt(paginationElement.dataset.currentPage) || 1;
            // Update data attributes for consistency
            this.dataset.previousPage = this.previousUrl;
            this.dataset.currentPage = this.currentPage.toString();
          } else {
            this.previousUrl = '';
            this.dataset.previousPage = '';
          }
          
          // Hide button if no more previous pages
          if (this.previousUrl === '' || this.currentPage <= 1) {
            if (this.previousButton) {
              this.previousButton.setAttribute('hidden', '');
            }
          }
          
          this.previousLoader.setAttribute('hidden', '');
          this.updateLoadedProductNumber(true, productsLoaded);
          swatches();
        })
        .catch((e) => {
          console.error(e);
          this.previousLoader.setAttribute('hidden', '');
        });
    }
  }
}

customElements.define('infinite-pagination', InfinitePagination);
